/* eslint-disable react/no-danger */
import React from "react";
interface Props {
  bottomDescription?: string;
  seoBottomText?: string;
}
const BottomDescription = ({
  bottomDescription
}: Props) => <>
    {bottomDescription && <div className="padded-subtle small px-5 xs:p-0 sm:p-0 md:p-0 lg:p-0">
        <div className="no-margin" dangerouslySetInnerHTML={{
      __html: bottomDescription
    }} />
      </div>}
  </>;
export default BottomDescription;